import React from "react";
import { Button } from "@material-ui/core";
import { ArrowBackIos } from "@material-ui/icons";
import "./backButton.scss";

interface BackButtonProps {
    onClick: (event: any) => void;
    disabled?: boolean;
}

export default function BackButton(props: BackButtonProps) {
    return (
        <Button variant="contained" startIcon={<ArrowBackIos />}
                className="back-button"
                onClick={props.onClick}
                disabled={props.disabled}
        >
            Powrót
        </Button>
    );
}
